import React from 'react';
import styles from './Statusbar.module.css';

export default function Statusbar({ left, right }) {
  return (
    <div className={styles.bar}>
      <div className={styles.left}>{left}</div>
      <div className={styles.right}>{right}</div>
    </div>
  );
}
